export default "__VITE_ASSET__6df9c68b__"